<div class="row m-2">
    <ng-template [ngTemplateOutlet]="textbox" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="textbox" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="checkbox" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="checkbox" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="switch" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="switch" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="radio" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="radio" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="textarea" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="textarea" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>
<div class="row m-2">
    <ng-template [ngTemplateOutlet]="numerictextbox" [ngTemplateOutletContext]="{disabled: false}">
    </ng-template>
    <ng-template [ngTemplateOutlet]="numerictextbox" [ngTemplateOutletContext]="{disabled: true}">
    </ng-template>
</div>

<!--Textbox-->
<ng-template #textbox let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Textbox
            </span>
            <input kendoTextBox maxlength="10" class="w-100" [disabled]="disabled" />
        </label>
    </div>
</ng-template>

<!--Checkbox-->
<ng-template #checkbox let-disabled='disabled'>
    <div class="col-4">
        <input id="checkbox" type="checkbox" [disabled]="disabled" kendoCheckBox>
        <label class="k-checkbox-label" for="checkbox"><span *ngIf="disabled">Disabled&nbsp;</span>Checkbox</label>
    </div>
</ng-template>

<!--Switch-->
<ng-template #switch let-disabled='disabled'>
    <div class="col-4">
        <label class="k-text-uppercase dark mr-2 w-100" for="active"><span *ngIf="disabled">Disabled&nbsp;</span><span
                *ngIf="!disabled">Enabled&nbsp;</span>
        </label>
        <kendo-switch onLabel="{{'YES' | translate }}" offLabel="{{'NO' | translate }}" [disabled]="disabled">
        </kendo-switch>
    </div>
</ng-template>

<!--Radio-->
<ng-template #radio let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Radio Group
            </span>
            <div>
                <span class="mr-2">
                    <input type="radio" value="RATE_BASED" name="metricType" id="radioRateBased" [disabled]="disabled"
                        kendoRadioButton />
                    <label class="k-radio-label" for="radioRateBased">{{'METRIC-TYPE-RATE' | translate}}
                    </label>
                </span>
                <span>
                    <input type="radio" value="COUNT_BASED" name="metricType" id="radioCountBased" [disabled]="disabled"
                        kendoRadioButton />
                    <label class="k-radio-label" for="radioCountBased">{{'METRIC-TYPE-COUNT' |
                        translate}}
                    </label>
                </span>
            </div>
        </label>
    </div>
</ng-template>

<!--Text Area-->
<ng-template #textarea let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Text Area
            </span>
            <textarea kendoTextArea rows="3" maxlength="1024" class="w-100" [disabled]="disabled"></textarea>
        </label>
    </div>
</ng-template>

<!--Numeric Textbox-->
<ng-template #numerictextbox let-disabled='disabled'>
    <div class="col-4">
        <label class="k-form-field">
            <span class="k-text-uppercase dark">
                <span *ngIf="disabled">Disabled&nbsp;</span>Numeric Textbox
            </span>
            <kendo-numerictextbox [format]="'n0'" class="w-100" [min]="0" [disabled]="disabled"></kendo-numerictextbox>
        </label>
    </div>
</ng-template>